import React from 'react';
export const CFIconCheckmark = {
    alias: 'checkmark',
    defaultTitle: 'Checkmark',
    source: ({ Path }) => (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M9.863 18a1 1 0 0 1-.729-.315l-4.863-5.18a1 1 0 1 1 1.457-1.368l4.125 4.39 8.408-9.201a1 1 0 0 1 1.477 1.348l-9.137 10a.998.998 0 0 1-.73.326h-.008Z' }))),
};
